<template>
    <div class="deal-share">
        <BackendHeader />

        <h1>Deal History &amp; Analysis</h1>
        <div class="analysis-header">
            <input v-model="searchQuery" placeholder="Term1..." />
            <input v-model="searchQuery2" placeholder="Term2..." />
            <button @click="search()">Search</button>
        </div>
        <div class="analysis-analytics">
            <h2>Analytics</h2>
            <div v-if="analytics.tableData" class="analysis-table">
                <RichTable :serverSide="analytics.serverSide"
                           class="overflow fixed-height"
                           :tableData="analytics.tableData"
                           :paging="true"
                           :isBusy="analytics.isBusy" />
            </div>
        </div>
        <div class="analysis-analytics">
            <h2>Order History</h2>
            <div v-if="orderHistory.tableData" class="analysis-table">
                <RichTable :serverSide="orderHistory.serverSide"
                           class="overflow fixed-height"
                           :tableData="orderHistory.tableData"
                           :paging="true"
                           :isBusy="orderHistory.isBusy" />
            </div>
        </div>

    </div>
</template>
<script>
    import settings from '@/settings'
    import api from '@/api'

    import BackendHeader from '@/components/BackendHeader'
    import RichTable from '@/components/RichTable'

    export default {
        data() {
            return {
                analytics: {
                    isBusy: false,
                    serverSide: {
                        refresh: this.analyticsRefresh,
                        pageNumber: 1,
                        pageSize: 20,
                        autoFilters: null,
                        headers: [],
                        sortBy: null,
                        asc: true,
                        restartPages: null,
                        additionalObject: {
                            searchQuery: null,
                            searchQuery2: null
                        }
                    },
                    tableData: null
                },
                orderHistory: {
                    isBusy: false,
                    serverSide: {
                        refresh: this.orderHistoryRefresh,
                        pageNumber: 1,
                        pageSize: 20,
                        autoFilters: null,
                        headers: [],
                        sortBy: null,
                        asc: true,
                        restartPages: null,
                        additionalObject: {
                            searchQuery: null,
                            searchQuery2: null
                        }
                    },
                    tableData: null
                },
                searchQuery: '',
                searchQuery2: ''
            }
        },
        methods: {
            async search() {
                this.analytics.serverSide.pageNumber = 1;
                this.orderHistory.serverSide.pageNumber = 1;
                await this.analyticsRefresh();
                await this.orderHistoryRefresh();
            },
            async analyticsRefresh() {

                this.analytics.serverSide.additionalObject = {
                    searchQuery: this.searchQuery,
                    searchQuery2: this.searchQuery2
                };

                console.log('REQUEST', this.analytics.serverSide)
                this.analytics.isBusy = true;
                let response = await api.analysis.searchAnalytics(this.analytics.serverSide);
                console.log('RESPONSE', response)
                if (response && response.data) {
                    this.analytics.serverSide = response.data;
                    this.analytics.serverSide.refresh = this.analyticsRefresh;
                    this.analytics.tableData = response.data.results;
                    
                }
                this.analytics.isBusy = false;

            },
            async orderHistoryRefresh() {

                this.orderHistory.serverSide.additionalObject = {
                    searchQuery: this.searchQuery,
                    searchQuery2: this.searchQuery2
                };

                console.log('REQUEST', this.orderHistory.serverSide)
                this.orderHistory.isBusy = true;
                let response = await api.analysis.searchOrderHistory(this.orderHistory.serverSide);
                console.log('RESPONSE', response)
                if (response && response.data) {
                    this.orderHistory.serverSide = response.data;
                    this.orderHistory.serverSide.refresh = this.orderHistoryRefresh;
                    this.orderHistory.tableData = response.data.results;

                }
                this.orderHistory.isBusy = false;

            }
        },
        created() {

        },
        computed: {

        },
        components: {
            BackendHeader,
            RichTable
        }
    }
</script>
<style>

    .analysis-table {
        font-family: 'Quicksand' !important;
        min-width: 1000px;
    }

    .tbl-title-text{
        max-width: 400px;
        overflow: hidden;
        text-align: left;
        white-space: nowrap;
    }

    h2{
        padding-top: 50px;
    }

</style>